import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import FormularioNews from '../components/FormularioNews';
import '../assets/styles/News.css';

// Importando las imágenes para noticias destacadas
import bannerHorarios from '../assets/images/images-featured-news/banner-horarios-atencion.png';
import bannerListadoUtiles from '../assets/images/images-featured-news/banner-utiles-escolares.webp';
import bannerReconocimientos from '../assets/images/images-featured-news/banner-reconocimientos.webp';


export default function News() {
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [formData, setFormData] = useState({
    titulo: '',
    descripcion: '',
    tipo_noticia: '',
    imagen: null
  });
  const [mensaje, setMensaje] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // ✅ Validar token al montar componente
  useEffect(() => {
    const validarToken = () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const ahora = Date.now() / 1000;
        if (payload.exp > ahora) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem('token');
        }
      } catch {
        localStorage.removeItem('token');
      }
    };

    validarToken();
  }, []);

  const token = localStorage.getItem('token');

  const handleChange = e => {
    const { name, value, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/news`, data, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMensaje('Noticia subida con éxito.');
      setFormData({ titulo: '', descripcion: '', tipo_noticia: '', imagen: null });
      setMostrarFormulario(false);
    } catch (err) {
      setMensaje(err.response?.data?.error || 'Error al subir noticia');
    }
  };

  const cerrarSesion = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    window.location.reload();
  };

  // Datos de las noticias destacadas
  const noticiasDestacadas = [
    {
      id: 1,
      titulo: "Horarios de Atención",
      descripcion: "Conoce nuestros horarios de atención durante la semana",
      imagen: bannerHorarios,
      ruta: "/horarios-atencion"
    },
    {
      id: 2,
      titulo: "Listado de Útiles Escolares 2026",
      descripcion: "Todo lo que necesitas para comenzar el año escolar",
      imagen: bannerListadoUtiles,
      ruta: "/listado-utiles"
    },
    {
      id: 3,
      titulo: "Reconocimientos",
      descripcion: "Distinciones y logros otorgados a nuestra institución educativa..",
      imagen: bannerReconocimientos,
      ruta: "/reconocimientos"
    }
  ];

  return (
    <div className="news-page">
      <Helmet>
        <title>Noticias | Colegio Cristiano Le Beau Jour</title>
        <meta
          name="description"
          content="Noticias destacadas del Colegio Cristiano Le Beau Jour: horarios de atención, listado de útiles escolares y reconocimientos de nuestra comunidad educativa en Viña del Mar."
        />
        <link rel="canonical" href="https://www.colegiocristianolebeaujour.cl/news" />
      </Helmet>
      <div className="news-header">
        <h1>Noticias del Colegio</h1>
        <p>Últimas publicaciones destacadas</p>
        {isAuthenticated && (
          <>
            <button className="read-more" onClick={() => setMostrarFormulario(true)}>Subir Noticia</button>
            <button className="read-more" onClick={cerrarSesion}>Cerrar Sesión</button>
          </>
        )}
      </div>

      {/* Sección de noticias destacadas */}
      <div className="destacadas-section">
        <h2 className="destacadas-title">Noticias Destacadas</h2>
        <div className="destacadas-container">
          {noticiasDestacadas.map((noticia, idx) => (
            <div
              key={noticia.id}
              className="destacada-card animated fadeIn"
              style={{ animationDelay: `${0.1 + idx * 0.15}s` }}
            >
              <Link to={noticia.ruta} className="destacada-link">
                <div className="destacada-image-container">
                  <img src={noticia.imagen} alt={noticia.titulo} className="destacada-img" />
                </div>
                <div className="destacada-content">
                  <h3>{noticia.titulo}</h3>
                  <p>{noticia.descripcion}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {mostrarFormulario && isAuthenticated && (
        <FormularioNews
          formData={formData}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onClose={() => setMostrarFormulario(false)}
          mensaje={mensaje}
        />
      )}
    </div>
  );
}
